// extracted by mini-css-extract-plugin
export default {"container":"StateScreen_container__ghRTg","header":"StateScreen_header__-7n2t","icon":"StateScreen_icon__LYHvQ"};